module.exports = __webpack_public_path__ + "img/avatar-s-7.5a5000fd.jpg";